import { useContext } from "react";
import { StoreContext } from "../store/Store";
import { GlobalRefContext } from "../store/GlobalRefs";
import { actionTypes } from "../store/storeTypes";

const headerStyle = { fontSize: 18, fontWeight: 600, textAlign: "center" };

export const Header = ({ children, title, label }) => {
  const [store, dispatch] = useContext(StoreContext);
  const grefs = useContext(GlobalRefContext);

  if (store) {
    //do nothing
  }

  const onMouseOver = () => {
    dispatch({
      type: actionTypes.SET_TITLEPOPUP,
      payload: { active: true, label: label, title: title },
    });
  };
  const onMouseOut = () => {
    dispatch({
      type: actionTypes.SET_TITLEPOPUP,
      payload: { active: false },
    });
  };

  return (
    <div
      ref={grefs.titleRefs.current[label]}
      style={headerStyle}
      onMouseOver={() => onMouseOver()}
      onMouseOut={() => onMouseOut()}
    >
      {children}
    </div>
  );
};
